<div class="row justify-content-center">
  <div class="col-12">

    <app-calculation-header [calculationId]="calculationId"></app-calculation-header>

    <router-outlet></router-outlet>
  </div>
</div> <!-- / .row -->